// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"7286e6ad","594":"c9c4cf86","766":"3e93f179","970":"c2152cd0"}[chunkId] + ".chunk.js";
};